import { CTA, CTAProps } from '@/components/CTA';
import { Typography } from '@eventbrite/marmalade';
import { SymbolCheckmarkIcon } from '@eventbrite/marmalade/icons';
import classNames from 'classnames';
import React from 'react';
import styles from './ListContent.module.scss';

export interface ListContentProps {
  title?: string;
  items: string[];
  cta?: CTAProps;
  showDivider?: boolean;
  className?: string;
}

export const ListContent: React.FC<ListContentProps> = ({
  title,
  items,
  cta,
  showDivider = false,
  className = '',
}) => {
  return (
    <div className={classNames(styles.list_container, className)}>
      <div className={styles.content}>
        {title && (
          <Typography as="h3" className={styles.title}>
            
          </Typography>
        )}
        <ul className={styles.list}>
          {items.map((item, idx) => (
            <li key={idx} className={styles.listItem}>
              <span className={styles.icon}>
                <SymbolCheckmarkIcon size="LG" color="var(--marm-color-success-fg-base, #006B23)" />
              </span>
              <Typography as="span" className={styles.itemText}>
                {item}
              </Typography>
            </li>
          ))}
        </ul>
        {cta && (
          <CTA label={cta.label} link={cta.link} type={cta.type} dataHeapId={cta.dataHeapId} />
        )}
      </div>
      {showDivider && <hr className={styles.divider} />}
    </div>
  );
};
